import { useState, useEffect } from 'react';
import Constant from '@/common/constant/Constant';
import { Checkbox, FormControlLabel } from '@material-ui/core';

// import elements
import ReplyEmailSubject from './elements/ReplyEmailSubject';
import ReplyEmailInput from './elements/ReplyEmailInput';
import ReplyEmailAttachment from './elements/ReplyEmailAttachment';
import ReplyEmailBody from './elements/ReplyEmailBody';
import ReplyCheckboxDeliver from './elements/ReplyCheckboxDeliver';



export default function ReplyEmailTicketForm({
    originTicket,
    currentEmailTicket,
    onclickReplyTicket,
    replyToEmailTicket,
    toEmailAddressList,
    setToEmailAddressList,
    ccEmailAddressList,
    setCcEmailAddressList,
    bccEmailAddressList,
    setBccEmailAddressList,
    listSuggestSearchEmail,
    setIsEdited,
    errorlist,
    register,
    setValue,
    getValues,
    setError,
    clearErrors,
    fileReplyUploadList,
    setFileReplyUploadList,
    replyDeliverStatus,
    setReplyDeliverStatus,
    currentTicketDeliverStatus,
    setCurrentTicketDeliverStatus,
    triggerEnableBtnSaveTicket
}) {
    
    const [currentFieldData, setCurrentFieldData] = useState([]);

    useEffect(() => {
        let listField = replyToEmailTicket?.listField
        if (listField) {
            setCurrentFieldData(listField) // use list field 
        }

    }, [replyToEmailTicket]);

    let fromSysFieldData = currentFieldData.find(field => field.sysField === 'from');
    let isCustomerMail = currentEmailTicket?.projectOrigin !== currentEmailTicket?.affiliationProject;
   
    return (
        <div className="addTicket addTicket-detail footer">
            {currentFieldData.map((fieldData, i) => {
                    if (replyToEmailTicket && fieldData.sysField === Constant.SYS_FIELD.FROM) {
                        return <></>
                    }
                    switch (fieldData.sysField) {
                        case Constant.SYS_FIELD.MAIL_SUBJECT:
                            return (
                                <ReplyEmailSubject
                                    detailTicket={originTicket}
                                    replyToEmailTicket={replyToEmailTicket}
                                    currentEmailTicket={currentEmailTicket}
                                    fieldData={fieldData}
                                    register={register}
                                    setValue={setValue}
                                    triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
                                />
                            )
                        case Constant.SYS_FIELD.FROM:
                        case Constant.SYS_FIELD.TO:
                        case Constant.SYS_FIELD.CC:
                        case Constant.SYS_FIELD.BCC:
                            return (
                                <ReplyEmailInput 
                                    originTicket={originTicket}
                                    fieldData={fieldData}
                                    replyToEmailTicket={replyToEmailTicket}
                                    toEmailAddressList={toEmailAddressList}
                                    setToEmailAddressList={setToEmailAddressList}
                                    ccEmailAddressList={ccEmailAddressList}
                                    setCcEmailAddressList={setCcEmailAddressList}
                                    bccEmailAddressList={bccEmailAddressList}
                                    setBccEmailAddressList={setBccEmailAddressList}
                                    listSuggestSearchEmail={listSuggestSearchEmail}
                                    fromSysFieldData={fromSysFieldData}
                                    currentEmailTicket={currentEmailTicket}
                                    setIsEdited={setIsEdited}
                                    triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
                                />
                            )
                        case 'mailBody':
                            return (
                                <>
                                <ReplyEmailBody 
                                    originTicket={originTicket}
                                    fieldData={fieldData}
                                    isCustomerMail={isCustomerMail}
                                    replyToEmailTicket={replyToEmailTicket}
                                    onclickReplyTicket={onclickReplyTicket}
                                    setIsEdited={setIsEdited}
                                    register={register}
                                    setValue={setValue}
                                    triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
                                />

                                <ReplyCheckboxDeliver 
                                    originTicket={originTicket}
                                    replyToEmailTicket={replyToEmailTicket}
                                    replyDeliverStatus={replyDeliverStatus}
                                    setReplyDeliverStatus={setReplyDeliverStatus}
                                    currentEmailTicket={currentEmailTicket}
                                    currentTicketDeliverStatus={currentTicketDeliverStatus}
                                    setCurrentTicketDeliverStatus={setCurrentTicketDeliverStatus}
                                    setIsEdited={setIsEdited}
                                />
                               
                                </>
                            )
                          
                        case 'attachments':
                            return (
                                <ReplyEmailAttachment 
                                    detailTicket={originTicket}
                                    fieldData={fieldData}
                                    replyToEmailTicket={replyToEmailTicket}
                                    register={register}
                                    setValue={setValue}
                                    getValues={getValues}
                                    setError={setError}
                                    clearErrors={clearErrors}
                                    errorlist={errorlist}
                                    setIsEdited={setIsEdited}
                                    fileReplyUploadList={fileReplyUploadList}
                                    setFileReplyUploadList={setFileReplyUploadList}
                                />
                            )
                        default:
                            return (<></>)
                    }
                })
            }
        </div>
    );
}


